import React from 'react';

import { createPortal } from 'react-dom';

type PortalRendererProps = {
  portalSelector?: string;
  children: React.ReactNode;
};

const renderedPortals = new Set<string>();

export const PortalRenderer: React.FC<PortalRendererProps> = ({ portalSelector, children }) => {
  if (!portalSelector) {
    return <>{children}</>;
  }

  if (renderedPortals.has(portalSelector)) {
    return null;
  }

  const mountNode = document.querySelector(portalSelector);
  if (!mountNode) {
    console.warn(`Portal target not found: "${portalSelector}"`);
    throw Error('Portal target not found');
  }

  renderedPortals.add(portalSelector);
  return createPortal(children, mountNode);
};
